// Phases:
//   INTRO   - Auto Earth flyover. Scroll locked.
//   MAP     - 2D MapLibre map of Konkan. Scroll zooms the map.
//   JOURNEY - Cinematic 4-chapter landscape experience. Scroll drives chapters.
//   PLOT    - 3D Nausiddhi land scene. Free orbit camera. Scroll drives page sections below.
export const scrollState = {
  progress: 0,
  velocity: 0,
  ready: false,

  phase: "INTRO",
  introProgress: 0,
  mapProgress: 0,
};

// In-memory flag: survives React SPA navigations but resets on every
// full page load (F5 / new tab). sessionStorage survives F5 — wrong
// for this use case where a fresh load must always play the INTRO.
let _hasSeenIntro = false;
export const hasSeenIntro = () => _hasSeenIntro;
export const markIntroSeen = () => { _hasSeenIntro = true; };

const listeners = new Set();
const phaseListeners = new Set();

export function onScrollChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

// Subscribe to phase transitions. Use this instead of setInterval-polling
// scrollState.phase from every component — the polling adds up to dozens
// of timers + setState calls per second that contribute to stutter.
export function onPhaseChange(fn) {
  phaseListeners.add(fn);
  return () => phaseListeners.delete(fn);
}

export function setScrollProgress(p, v = 0) {
  scrollState.progress = p;
  scrollState.velocity = v;
  listeners.forEach((fn) => fn(p, v));
}

export function setPhase(phase) {
  if (scrollState.phase === phase) return;
  scrollState.phase = phase;
  phaseListeners.forEach((fn) => fn(phase));
}

// Hard reset — call when HomePage remounts after SPA navigation.
// setPhase() has an early-return guard so it can't reset INTRO→INTRO;
// this bypasses it and forces all subscribers to re-sync.
export function resetScrollState() {
  scrollState.phase = "INTRO";
  scrollState.progress = 0;
  scrollState.velocity = 0;
  scrollState.introProgress = 0;
  scrollState.mapProgress = 0;
  scrollState.ready = false;
  phaseListeners.forEach((fn) => fn("INTRO"));
  listeners.forEach((fn) => fn(0, 0));
}

export function setIntroProgress(t) {
  scrollState.introProgress = t;
}

export function setMapProgress(t) {
  scrollState.mapProgress = t;
}
